<script setup lang="ts">
import { computed } from "vue";
import type { MemoryRegion } from "../types";
const props = defineProps<{ regions: MemoryRegion[]; addressSpace: string }>();
const visible = computed(() =>
  props.regions.filter((region) => region.address_space === props.addressSpace),
);
const total = computed(() =>
  visible.value.reduce((sum, region) => sum + Number.parseInt(region.size.slice(2), 16), 0),
);
function width(size: string) {
  const ratio = Number.parseInt(size.slice(2), 16) / Math.max(total.value, 1);
  return `${Math.max(12, ratio * 100)}%`;
}
</script>
<template>
  <div class="memory-map" aria-label="Memory regions">
    <article
      v-for="region in visible"
      :key="`${region.address_space}${region.base}`"
      :style="{ width: width(region.size) }"
    >
      <div>
        <strong>{{ region.name }}</strong
        ><span>{{ region.kind }}</span>
      </div>
      <code>{{ region.base }}</code
      ><small>{{ region.size }}</small>
    </article>
    <p v-if="!visible.length" class="empty">No memory regions in this address-space view.</p>
  </div>
</template>
